var gql = require("@apollo/client").gql;

const OPERATOR_HEADER_QUERY = gql`
	query OPERATOR_HEADER_QUERY($filter: String!) {
		provider(filter: $filter) {
			id
			name
			url_name
			logo
			logo_2
			logo_preview
			mobile_operator
			global {
				id
			}
			order_types {
				id
				name
			}
			rating {
				expert {
					final
				}
				order_types {
					counted
					review_all
					order_type_id
					in_main_rating
					rating
					rating_plus
					rating_minus
					rating_middle
					review_kind
					provider_answer_count
					position
				}
			}
			region {
				id
				name
				url
			}
			info {
				cnt_tariffs
				cnt_action_tariffs
				cnt_news
			}
			specifications {
				name
				image
				value
				description
			}
			vip_provider
			contacts {
				city
				site
				phones
				phone_support
				link
				card
				street
				home_office
				name_legal
			}
			filters {
				speed {
					min
					max
					key
				}
				price {
					min
					max
					key
				}
				districts {
					id
					name
				}
				types {
					key
					name
					count
				}
			}
		}
	}
`;

export default OPERATOR_HEADER_QUERY;
